import React, { memo } from "react";
import { Dropdown } from "react-bootstrap";

import { Portal, RadioButton } from "components";

import styles from "./table.module.scss";

type OptionType = { value: string | number; name: string };

type TableDropdownProps = {
	options: OptionType[];
	selected?: OptionType;
	onSelect?: Function;
	id: string;
};

const TableDropdown = ({
	options = [],
	selected,
	onSelect,
	id,
}: TableDropdownProps) => (
	<Dropdown onClick={e => e.stopPropagation()}>
		<Dropdown.Toggle as="span" className={styles.dropdownToggle}>
			{selected?.name}
		</Dropdown.Toggle>
		<Portal>
			<Dropdown.Menu className={styles.dropdownMenu}>
				{options.map(({ value, name }, key) => {
					const checked = selected?.value === value;
					return (
						<Dropdown.Item
							key={key}
							as="div"
							className={styles.dropdownItem}
						>
							<RadioButton
								value={value}
								name={id}
								id={value}
								label={name}
								onChange={onSelect}
								checked={checked}
							/>
						</Dropdown.Item>
					);
				})}
			</Dropdown.Menu>
		</Portal>
	</Dropdown>
);

export default memo(TableDropdown);
